// Config for marketing consent toggle on sign up
export const marketingConsentActivated = true;
// Brand privacy url to be added
export const brandPrivacyPolicyUrl = 'https://www.sandqvist.com/en/privacy-policy/';
